import { TFunction } from 'i18next';
import _ from 'lodash';
// import { assignmentMetricDescriptors } from '../assignment/assignmentMetric.default';
// import { itemSetMetricDescriptors } from '../itemSet/itemSetMetric.default';
// import { itemStatsMetricDescriptors } from '../itemStats/itemStatsMetric.default';
// import { locationMetricDescriptors } from '../location/locationMetric.default';
import { getAssignmentMetricDescriptors } from '../assignment/assignmentMetric.default';
import { getItemSetMetricDescriptors } from '../itemSet/itemSetMetric.default';
import { getItemStatsMetricDescriptors } from '../itemStats/itemStatsMetric.default';
import { getLocationMetricDescriptors } from '../location/locationMetric.default';
import {
  SimulationHqMetric,
  SimulationHqMetricDescriptorBase,
} from './simulationHqMetric.types';

export const getSimulationHqMetricDescriptors = (
  t: TFunction<'app'>,
): SimulationHqMetricDescriptorBase[] => [
  ...getItemSetMetricDescriptors(t),
  ...getItemStatsMetricDescriptors(t),
  ...getAssignmentMetricDescriptors(t),
  ...getLocationMetricDescriptors(t),
  {
    type: 'stockUomHeight',
    path: 'stockUomHeight',
    rangeType: 'range-linear',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'stockUomNetWeight',
    path: 'stockUomNetWeight',
    rangeType: 'range-linear',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'stockUomVolume',
    path: 'stockUomVolume',
    rangeType: 'range-linear',
    aggregationFn: 'min',
    qualitativePaletteId: 'dimension',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'stockUomMaxStack',
    path: 'stockUomMaxStack',
    rangeType: 'distinct',
    aggregationFn: 'min',
    sequentialPaletteId: 'elevation-sort',
    nullValueBucketTitle: t('Unlimited', { ns: 'app' }),
  },
];

export const getSimulationHqMetricDescriptorsMap = (t: TFunction<'app'>) =>
  _.keyBy(getSimulationHqMetricDescriptors(t), d => d.type) as Record<
    SimulationHqMetric,
    SimulationHqMetricDescriptorBase
  >;
